import { render, staticRenderFns } from "./InternalBanner.vue?vue&type=template&id=3b4a9e5e&scoped=true&"
import script from "./InternalBanner.vue?vue&type=script&lang=js&"
export * from "./InternalBanner.vue?vue&type=script&lang=js&"
import style0 from "./InternalBanner.vue?vue&type=style&index=0&id=3b4a9e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a9e5e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/InternalBanner.vue
// module id = 101
// module chunks = 0